import React, { forwardRef, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import CatalogPropTypes from 'utils/propTypes/catalogs';

import styles from './styles.module.scss';

const ButtonFilter = memo(
	forwardRef(
		(
			{
				icon,
				text,
				name,
				value,
				active,
				title,
				onClick,
				className,
				size,
				iconPosition,
				ariaLabel,
				ariaHideTextNode,
				...restProps
			},
			ref
		) => {
			const buttonCx = cx(
				styles.button,
				styles[`iconPosition_${iconPosition}`],
				styles[`size_${size}`],
				{
					[styles.active]: active,
					[styles.withIcon]: !!icon
				},
				className
			);

			const handleClick = useCallback(() => {
				onClick(name, value);
			}, [onClick, name, value]);

			return (
				<button
					className={buttonCx}
					type="button"
					title={title}
					onClick={handleClick}
					ref={ref}
					data-aria-label={ariaLabel}
					{...restProps}
				>
					{icon && (
						<Icon icon={icon} className={cx(styles.icon, styles[icon])} />
					)}
					{text && (
						<span aria-hidden="true" className={styles.text}>
							{text}
						</span>
					)}
					<span className={styles.screenreaderText} data-aria-text="true">
						{ariaLabel || text}
					</span>
				</button>
			);
		}
	)
);

ButtonFilter.propTypes = {
	onClick: PropTypes.func,
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	text: PropTypes.string,
	title: PropTypes.string,
	name: PropTypes.string,
	value: CatalogPropTypes.filterButtonValue,
	active: PropTypes.bool,
	iconPosition: PropTypes.oneOf(['right', 'left']),
	size: PropTypes.oneOf(['mobileSmall']),
	className: PropTypes.string,
	ariaLabel: PropTypes.string,
	ariaHideTextNode: PropTypes.bool
};

ButtonFilter.defaultProps = {
	active: false,
	iconPosition: 'left'
};

export default ButtonFilter;
